import { TitledPaper } from '@dai/components'
import { Grid2 as Grid } from '@mui/material'

import CreateAccount from '@/components/auth/CreateAccount'
import useT from '@/i18n/useT'

function SignUp() {
  const { t } = useT()

  return (
    <Grid container spacing={6}>
      <Grid size={{ xs: 12 }}>
        <TitledPaper title={t('signup.title')} subtitle={t('signup.subtitle')}>
          <CreateAccount />
        </TitledPaper>
      </Grid>
    </Grid>
  )
}

export default SignUp
